export const currencyList: { value: string, label: string, symbol: string }[] = [
    { value: "AFA", label: "AFA - ؋", symbol: "؋" },
    { value: "ALL", label: "ALL - Lek", symbol: "Lek" },
    { value: "DZD", label: "DZD - دج", symbol: "دج" },
    { value: "AOA", label: "AOA - Kz", symbol: "Kz" },
    { value: "ARS", label: "ARS - $", symbol: "$" },
    { value: "AMD", label: "AMD - ֏", symbol: "֏" },
    { value: "AWG", label: "AWG - ƒ", symbol: "ƒ" },
    { value: "AUD", label: "AUD - $", symbol: "$" },
    { value: "AZN", label: "AZN - m", symbol: "m" },
    { value: "BSD", label: "BSD - B$", symbol: "B$" },
    { value: "BHD", label: "BHD - .د.ب", symbol: ".د.ب" },
    { value: "BDT", label: "BDT - ৳", symbol: "৳" },
    { value: "BBD", label: "BBD - Bds$", symbol: "Bds$" },
    { value: "BYR", label: "BYR - Br", symbol: "Br" },
    { value: "BEF", label: "BEF - fr", symbol: "fr" },
    { value: "BZD", label: "BZD - $", symbol: "$" },
    { value: "BMD", label: "BMD - $", symbol: "$" },
    { value: "BTN", label: "BTN - Nu.", symbol: "Nu." },
    { value: "BTC", label: "BTC - ฿", symbol: "฿" },
    { value: "BOB", label: "BOB - Bs.", symbol: "Bs." },
    { value: "BAM", label: "BAM - KM", symbol: "KM" },
    { value: "BWP", label: "BWP - P", symbol: "P" },
    { value: "BRL", label: "BRL - R$", symbol: "R$" },
    { value: "GBP", label: "GBP - £", symbol: "£" },
    { value: "BND", label: "BND - B$", symbol: "B$" },
    { value: "BGN", label: "BGN - Лв.", symbol: "Лв." },
    { value: "BIF", label: "BIF - FBu", symbol: "FBu" },
    { value: "KHR", label: "KHR - KHR", symbol: "KHR" },
    { value: "CAD", label: "CAD - $", symbol: "$" },
    { value: "CVE", label: "CVE - $", symbol: "$" },
    { value: "KYD", label: "KYD - $", symbol: "$" },
    { value: "XOF", label: "XOF - CFA", symbol: "CFA" },
    { value: "XAF", label: "XAF - FCFA", symbol: "FCFA" },
    { value: "CLP", label: "CLP - $", symbol: "$" },
    { value: "CNY", label: "CNY - ¥", symbol: "¥" },
    { value: "COP", label: "COP - $", symbol: "$" },
    { value: "KMF", label: "KMF - CF", symbol: "CF" },
    { value: "CDF", label: "CDF - FC", symbol: "FC" },
    { value: "CRC", label: "CRC - ₡", symbol: "₡" },
    { value: "HRK", label: "HRK - kn", symbol: "kn" },
    { value: "CUC", label: "CUC - $", symbol: "$" },
    { value: "CZK", label: "CZK - Kč", symbol: "Kč" },
    { value: "DKK", label: "DKK - kr", symbol: "kr" },
    { value: "DJF", label: "DJF - Fdj", symbol: "Fdj" },
    { value: "DOP", label: "DOP - $", symbol: "$" },
    { value: "XCD", label: "XCD - $", symbol: "$" },
    { value: "EGP", label: "EGP - £", symbol: "£" },
    { value: "ERN", label: "ERN - Nfk", symbol: "Nfk" },
    { value: "ETB", label: "ETB - Br", symbol: "Br" },
    { value: "EUR", label: "EUR - €", symbol: "€" },
    { value: "FKP", label: "FKP - £", symbol: "£" },
    { value: "FJD", label: "FJD - $", symbol: "$" },
    { value: "GMD", label: "GMD - D", symbol: "D" },
    { value: "GEL", label: "GEL - ₾", symbol: "₾" },
    { value: "GHS", label: "GHS - GH₵", symbol: "GH₵" },
    { value: "GIP", label: "GIP - £", symbol: "£" },
    { value: "GTQ", label: "GTQ - Q", symbol: "Q" },
    { value: "GNF", label: "GNF - FG", symbol: "FG" },
    { value: "GYD", label: "GYD - $", symbol: "$" },
    { value: "HTG", label: "HTG - G", symbol: "G" },
    { value: "HNL", label: "HNL - L", symbol: "L" },
    { value: "HKD", label: "HKD - $", symbol: "$" },
    { value: "HUF", label: "HUF - Ft", symbol: "Ft" },
    { value: "ISK", label: "ISK - kr", symbol: "kr" },
    { value: "INR", label: "INR - ₹", symbol: "₹" },
    { value: "IDR", label: "IDR - Rp", symbol: "Rp" },
    { value: "IRR", label: "IRR - ﷼", symbol: "﷼" },
    { value: "IQD", label: "IQD - ع.د", symbol: "ع.د" },
    { value: "ILS", label: "ILS - ₪", symbol: "₪" },
    { value: "JMD", label: "JMD - J$", symbol: "J$" },
    { value: "JPY", label: "JPY - ¥", symbol: "¥" },
    { value: "JOD", label: "JOD - JD", symbol: "JD" },
    { value: "KZT", label: "KZT - ₸", symbol: "₸" },
    { value: "KES", label: "KES - KSh", symbol: "KSh" },
    { value: "KPW", label: "KPW - ₩", symbol: "₩" },
    { value: "KRW", label: "KRW - ₩", symbol: "₩" },
    { value: "KWD", label: "KWD - KD", symbol: "KD" },
    { value: "KGS", label: "KGS - som", symbol: "som" },
    { value: "LAK", label: "LAK - ₭", symbol: "₭" },
    { value: "LBP", label: "LBP - ل.ل", symbol: "ل.ل" },
    { value: "LSL", label: "LSL - L", symbol: "L" },
    { value: "LRD", label: "LRD - $", symbol: "$" },
    { value: "LYD", label: "LYD - LD", symbol: "LD" },
    { value: "MOP", label: "MOP - P", symbol: "P" },
    { value: "MKD", label: "MKD - ден", symbol: "ден" },
    { value: "MGA", label: "MGA - Ar", symbol: "Ar" },
    { value: "MWK", label: "MWK - MK", symbol: "MK" },
    { value: "MYR", label: "MYR - RM", symbol: "RM" },
    { value: "MVR", label: "MVR - Rf", symbol: "Rf" },
    { value: "MRO", label: "MRO - UM", symbol: "UM" },
    { value: "MUR", label: "MUR - ₨", symbol: "₨" },
    { value: "MXN", label: "MXN - $", symbol: "$" },
    { value: "MDL", label: "MDL - L", symbol: "L" },
    { value: "MNT", label: "MNT - ₮", symbol: "₮" },
    { value: "MAD", label: "MAD - د.م.", symbol: "د.م." },
    { value: "MZN", label: "MZN - MT", symbol: "MT" },
    { value: "MMK", label: "MMK - K", symbol: "K" },
    { value: "NAD", label: "NAD - $", symbol: "$" },
    { value: "NPR", label: "NPR - ₨", symbol: "₨" },
    { value: "ANG", label: "ANG - ƒ", symbol: "ƒ" },
    { value: "NZD", label: "NZD - $", symbol: "$" },
    { value: "NIO", label: "NIO - C$", symbol: "C$" },
    { value: "NGN", label: "NGN - ₦", symbol: "₦" },
    { value: "NOK", label: "NOK - kr", symbol: "kr" },
    { value: "OMR", label: "OMR - ر.ع.", symbol: "ر.ع." },
    { value: "PKR", label: "PKR - ₨", symbol: "₨" },
    { value: "PAB", label: "PAB - B/.", symbol: "B/." },
    { value: "PGK", label: "PGK - K", symbol: "K" },
    { value: "PYG", label: "PYG - ₲", symbol: "₲" },
    { value: "PEN", label: "PEN - S/.", symbol: "S/." },
    { value: "PHP", label: "PHP - ₱", symbol: "₱" },
    { value: "PLN", label: "PLN - zł", symbol: "zł" },
    { value: "QAR", label: "QAR - ر.ق", symbol: "ر.ق" },
    { value: "RON", label: "RON - lei", symbol: "lei" },
    { value: "RUB", label: "RUB - ₽", symbol: "₽" },
    { value: "RWF", label: "RWF - FRw", symbol: "FRw" },
    { value: "SHP", label: "SHP - £", symbol: "£" },
    { value: "WST", label: "WST - T", symbol: "T" },
    { value: "STD", label: "STD - Db", symbol: "Db" },
    { value: "SAR", label: "SAR - ر.س", symbol: "ر.س" },
    { value: "RSD", label: "RSD - РСД", symbol: "РСД" },
    { value: "SCR", label: "SCR - ₨", symbol: "₨" },
    { value: "SLL", label: "SLL - Le", symbol: "Le" },
    { value: "SGD", label: "SGD - $", symbol: "$" },
    { value: "SBD", label: "SBD - $", symbol: "$" },
    { value: "SOS", label: "SOS - Sh", symbol: "Sh" },
    { value: "ZAR", label: "ZAR - R", symbol: "R" },
    { value: "SSP", label: "SSP - £", symbol: "£" },
    { value: "LKR", label: "LKR - ₨", symbol: "₨" },
    { value: "SDG", label: "SDG - ج.س.", symbol: "ج.س." },
    { value: "SRD", label: "SRD - $", symbol: "$" },
    { value: "SZL", label: "SZL - L", symbol: "L" },
    { value: "SEK", label: "SEK - kr", symbol: "kr" },
    { value: "CHF", label: "CHF - Fr.", symbol: "Fr." },
    { value: "SYP", label: "SYP - £", symbol: "£" },
    { value: "TWD", label: "TWD - $", symbol: "$" },
    { value: "TJS", label: "TJS - SM", symbol: "SM" },
    { value: "TZS", label: "TZS - Sh", symbol: "Sh" },
    { value: "THB", label: "THB - ฿", symbol: "฿" },
    { value: "TOP", label: "TOP - T$", symbol: "T$" },
    { value: "TTD", label: "TTD - TT$", symbol: "TT$" },
    { value: "TND", label: "TND - DT", symbol: "DT" },
    { value: "TRY", label: "TRY - ₺", symbol: "₺" },
    { value: "TMT", label: "TMT - m", symbol: "m" },
    { value: "UGX", label: "UGX - USh", symbol: "USh" },
    { value: "UAH", label: "UAH - ₴", symbol: "₴" },
    { value: "AED", label: "AED - د.إ", symbol: "د.إ" },
    { value: "GBP", label: "GBP - £", symbol: "£" },
    { value: "USD", label: "USD - $", symbol: "$" },
    { value: "UYU", label: "UYU - $", symbol: "$" },
    { value: "UZS", label: "UZS - soʻm", symbol: "soʻm" },
    { value: "VUV", label: "VUV - Vt", symbol: "Vt" },
    { value: "VEF", label: "VEF - Bs", symbol: "Bs" },
    { value: "VND", label: "VND - ₫", symbol: "₫" },
    { value: "YER", label: "YER - ﷼", symbol: "﷼" },
    { value: "ZMW", label: "ZMW - ZK", symbol: "ZK" }
  ];